<template>
  <div class="layout-col">
    <section class="-wrapper-tile -wrapper-column -h-center-">
      <div class="-header">
        <div v-if="'AM'=== userInfo.auth">
          <p class="-h2 -font-weight-medium">{{  $t('pages_dashboard_product_cost_last_month.title') }}
            <g-tooltip-wrapper>
              <g-icon name="info" color="gray-1" class="-ml-1"></g-icon>
              <g-tooltip direction="top">
                <span v-html="$t('pages_dashboard_product_top3.tooltip')" />
              </g-tooltip>
            </g-tooltip-wrapper>
          </p>
        </div>
        <div v-else>
          <p class="-h2 -font-weight-medium">{{  $t('pages_dashboard_product_cost_last_month.title.AM') }}

            <g-tooltip-wrapper>
              <g-icon name="info" color="gray-1" class="-ml-1"></g-icon>
              <g-tooltip direction="top">
                <span v-html="$t('pages_dashboard_product_top3.tooltip')" />
              </g-tooltip>
            </g-tooltip-wrapper>
          </p>
        </div>
      </div>
      <div class="-wrapper-column -wrapper-v-h-center -width-100 -height-dashboard-1 -px-5 -py-4" @click="goProductRank" style="cursor: pointer">
        <div class="-wrapper -wrapper-v-h-center">
          <p class="-font-size-14 -font-weight-medium">{{ $t('pages_dashboard_product_cost_last_month.count') }}</p>
          <p id="dashboard-product-top3-product-count" class="-number l- -ml-5">{{ productsTopTotal | comma }}</p>
        </div>
        <div class="-wrapper -width-100 -mt-2" >
          <div class="-wrapper between- v-center- -width-100 -px-4 -border-bottom -list-item-height-40" v-for="(top, index) in productsTopList" :key="top.name">
            <div class="-wrapper v-center-" style="width: calc(100% - 95px)">
              <span class="-font-size-12">{{ index + 1 }}.</span>
              <span :id="'dashboard-product-top3-product-name-'+top.productName" class="-ml-4 -font-size-14 -ellipsis" style="line-height: 1.5; flex: 1 1 0%;">
                {{ top.productName }}
              </span>
            </div>
            <p :id="'dashboard-product-top3-product-amount-'+top.productName" class="-font-size-12 text-right- -color-gray-1" style="width: 95px;">{{ top.totalTradeAmountByKrw | comma }}{{ $t('pages_dashboard_product_cost_last_month.currency') }}</p>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {CURRENCY_SYMBOL} from "@/constants/constants";

export default {
  name: 'product-cost-list-prev-month',
  componentName: 'ProductCostListPrevMonth',
  data () {
    return {
      productsTopList: [],
      productsTopTotal: '0'
    }
  },
  computed: {
    ...mapGetters('dashboard', ['productsTop', 'productsTopCount']),
    ...mapGetters('user', ['userInfo']),
  },
  watch: {
    productsTop() {
      this.productsTopList = this.productsTop
      this.productsTopTotal = this.productsTopCount
    }
  },
  methods: {
    goProductRank() {
      this.$router.push('/product/rank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/components/ProductCostListPrevMonth.vue